import './scroll_hero';
import './services_list';

window.addEventListener("DOMContentLoaded", () => {
    document.querySelector(".toggle").onclick = function() {
      document.querySelector("body").classList.toggle("menu-open");
    };
  });

  AOS.init({
      once: true,
  });

  let menu_has_children = document.querySelectorAll('.menu-item-has-children')
  menu_has_children.forEach(menu=>{
      let plusBtns = menu.querySelectorAll('.plus')
      plusBtns.forEach(btn =>{
          btn.addEventListener('click', ()=>{
              
              if(menu.classList.contains('active')){
                  menu_has_children.forEach(el=>{
                      el.classList.remove('active')
                  })
                  
              }else{
                  menu_has_children.forEach(el=>{
                      el.classList.remove('active')
                  })
                  menu.classList.add('active')
              }
              
          })
      })
      
      let uls = menu.querySelectorAll('ul')
      uls.forEach(ul =>{
          ul.style.height = 'auto';
          ul.setAttribute('style', `--tooltip-height: ${ul.scrollHeight}px`);
      })

      window.addEventListener('resize', ()=>{
          uls.forEach(ul=>{
              ul.style.height = 'auto';
              ul.setAttribute('style', `--tooltip-height: ${ul.scrollHeight}px`);
          })
      })
  })